import bootstrap from 'bootstrap';

// offsets the target element's position when using on-page scroll nav for mobile
// will need to modify this script for desktop as well once the main nav menu is in place
class SideNav
{
    navLinks: NodeListOf<HTMLElement>;
    storiesLink: HTMLElement;
    storiesSection: HTMLElement;
    
    constructor()
    {
        this.init();
    }

    init()
    {
        this.navLinks = document.querySelectorAll('#scroll-nav-mobile .nav-link');

        // Call the function for each nav
        this.handleNavScroll('#scroll-nav-mobile', 59);  // this value will need adjustment once main nav is built in
        this.handleNavScroll('#scroll-nav', 160);  // this value might need adjustment

        this.navLinks.forEach(link => {
            link.addEventListener('click', this.handleNavLinkClick);
        });   
    }

 
    handleNavScroll = (navId: string, positionFromTop: number) => {
        const navLinks = document.querySelectorAll(`${navId} .nav-link`);

        const onScroll = () => {
            let currentActive: Element | null = null;
            const overviewLink = Array.from(navLinks).find(link => link.getAttribute('href') === '#overview');
            
            // Initially set the #overview nav-link as active
            currentActive = overviewLink;

            navLinks.forEach(link => {
                const target = document.querySelector(link.getAttribute('href') as string) as HTMLElement;
                
                if (target) {
                    const rect = target.getBoundingClientRect();
                    let currentThreshold = positionFromTop;
                    
                    if (rect.top <= currentThreshold && (rect.top + rect.height) > currentThreshold) {
                        currentActive = link;
                    }

                    link.classList.remove('d-none');
                } else{
                    link.classList.add('d-none');
                }
            });

            // Remove active class from all links
            navLinks.forEach(link => link.classList.remove('active'));
    
            // Add active class to the current link
            if (currentActive) {
                currentActive.classList.add('active');
            }
        };
    
        // Attach the scroll event listener
        window.addEventListener('scroll', onScroll);

        // Attach the resize event listener
        window.addEventListener('resize', onScroll);
    
        // Call the onScroll function initially to set the correct state
        onScroll();
    };
    
    handleNavLinkClick(event: Event) {
        event.preventDefault();

        const targetId = (event.currentTarget as HTMLAnchorElement).getAttribute('href');
        if (!targetId) return;

        const targetElement = document.querySelector(targetId) as HTMLElement;
        if (!targetElement) return;

        let offsetTop = 58; // Default value
        if (targetId === "#overview" && targetElement.classList.contains('has-mandatory')) {
            offsetTop = 95;
        }

        // Simulate a click on the accordion button
        const accordionBtn = document.querySelector('[data-bs-target="#scroll-nav-mobile-accordion"]');
        if (accordionBtn) {
            accordionBtn.dispatchEvent(new Event('click'));
            // console.log('mobile nav clicked');
        }

        const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offsetTop;
        window.scrollTo({
            top: topPosition,
            behavior: "smooth"
        });
    }
}

export default SideNav;
